import React, { Component } from "react";
import {
  IonButton,
  IonGrid,
  IonCol,
  IonRow,
  IonLabel,
  IonToggle,
  IonSegment,
  IonSegmentButton,
  IonRange,
} from "@ionic/react";

// css
import "../Shared.css";
import "../../App.css";
import "./FontPopover.css";

// controllers
import {
  IScreenProps,
  IUser,
  IGuideline,
  IGuidelineSummary,
  IAlgorithm,
  IAnnotation,
  IClinicalNotice,
} from "../Interfaces";
import DataController from "../controllers/DataController";
import { AlphaPicker, HuePicker } from "react-color";

// images
import iconTextIncrease from "../assets/Button_Text_Increase@3x.png";
import iconTextIncreaseDark from "../assets/Button_Text_Increase_Dark@3x.png";
import iconTextDecrease from "../assets/Button_Text_Decrease@3x.png";
import iconTextDecreaseDark from "../assets/Button_Text_Decrease_Dark@3x.png";
import iconLineIncrease from "../assets/Button_Line_Increase@3x.png";
import iconLineIncreaseDark from "../assets/Button_Line_Increase_Dark@3x.png";
import iconLineDecrease from "../assets/Button_Line_Decrease@3x.png";
import iconLineDecreaseDark from "../assets/Button_Line_Decrease_Dark@3x.png";
import iconTickDark from "../assets/Button_Tick_Dark@3x.png";
import toggleOn from "../assets/Controls_Switches_Light_On@3x.png";
import toggleOff from "../assets/Controls_Switches_Light_Off@3x.png";
import toggleOnDark from "../assets/Controls_Switches_Dark_On@3x.png";
import toggleOffDark from "../assets/Controls_Switches_Dark_Off@3x.png";
import RemoteDataController from "../controllers/RemoteDataController";

type Props = {
  screenProps: IScreenProps;
  features: string[];
};
type State = {
  tab: string;
};

class FontPopover extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      tab: "Text",
    };
  }

  render() {
    let fontSizePercentage = 100 + this.props.screenProps.fontSizeChange * 10;

    let lineHeightPercentage = 100;
    switch (this.props.screenProps.lineHeightChange) {
      case 1:
        lineHeightPercentage = 80;
        break;
      case 1.5:
        lineHeightPercentage = 100;
        break;
      case 2:
        lineHeightPercentage = 120;
        break;
      case 2.5:
        lineHeightPercentage = 140;
        break;
      case 3:
        lineHeightPercentage = 160;
        break;
      case 3.5:
        lineHeightPercentage = 180;
        break;
      case 4:
        lineHeightPercentage = 200;
        break;

      default:
        break;
    }

    let isLowVisMode =
      this.props.screenProps.fontSizeChange === 5 &&
      this.props.screenProps.lineHeightChange === 3 &&
      this.props.screenProps.fontWeight === "bold";
    let isBoldText = this.props.screenProps.fontWeight === "bold";

    let tabs = ["Text", "Fonts", "Speech", "Display"];

    return (
      <div className="fontPopoverContainer">
        <div className="fontPopoverTabsContainer">
          {tabs.map((tab, index) => {
            return (
              <div
                key={index}
                className={`fontPopoverTab ${this.state.tab === tab ? "fontPopoverTabSelected" : ""}`}
                onClick={() => {
                  this.setState({ tab });
                  RemoteDataController.logEvent("accessability_popover_tab_clicked", { tab: tab });
                }}
              >
                {tab}
              </div>
            );
          })}
        </div>
        {this.state.tab === "Text" ? (
          <div>
            <div className="fontPopoverFontSizeControls">
              <div className="fontPopoverIncrease" onClick={() => this.props.screenProps.decreaseFontSize()}>
                <img
                  className="buttonTextDecrease icon-44"
                  src={this.props.screenProps.darkMode ? iconTextDecreaseDark : iconTextDecrease}
                  alt=""
                />
              </div>
              <div className="fontPopoverText">
                <div>{fontSizePercentage}%</div>
              </div>
              <div className="fontPopoverDecrease" onClick={() => this.props.screenProps.increaseFontSize()}>
                <img
                  className="buttonTextIncrease icon-44"
                  src={this.props.screenProps.darkMode ? iconTextIncreaseDark : iconTextIncrease}
                  alt=""
                />
              </div>
            </div>

            <div className="fontPopoverLineHeightControls">
              <div className="fontPopoverIncrease" onClick={() => this.props.screenProps.decreaseLineHeight()}>
                <img
                  className="buttonTextDecrease icon-44"
                  src={this.props.screenProps.darkMode ? iconLineDecreaseDark : iconLineDecrease}
                  alt=""
                />
              </div>
              <div className="fontPopoverText">
                <div>{lineHeightPercentage}%</div>
              </div>
              <div className="fontPopoverDecrease" onClick={() => this.props.screenProps.increaseLineHeight()}>
                <img
                  className="buttonTextIncrease icon-44"
                  src={this.props.screenProps.darkMode ? iconLineIncreaseDark : iconLineIncrease}
                  alt=""
                />
              </div>
            </div>

            <div className="fontPopoverRow">
              <div>Bold text</div>
              {/* <IonToggle color="success" mode='ios' checked={this.props.screenProps.fontWeight === 'bold'} onIonChange={e => {
                if (e.detail.checked) {
                  this.props.screenProps.setFontWeight('bold');
                } else {
                  this.props.screenProps.setFontWeight('400');
                }
              }} /> */}
              <div
                className="fontPopoverToggle"
                onClick={() => {
                  this.props.screenProps.setFontWeight(isBoldText ? "400" : "bold");
                }}
              >
                <img
                  className="icon-toggle"
                  src={
                    isBoldText
                      ? this.props.screenProps.darkMode
                        ? toggleOnDark
                        : toggleOn
                      : this.props.screenProps.darkMode
                      ? toggleOffDark
                      : toggleOff
                  }
                  alt=""
                />
              </div>
            </div>
            <div className="fontPopoverRow">
              <div>Low vis mode</div>
              {/* <IonToggle color="success" mode='ios' checked={this.props.screenProps.lowVisMode} onIonChange={e => {this.props.screenProps.setLowVisMode(e.detail.checked)}} /> */}
              <div
                className="fontPopoverToggle"
                onClick={() => {
                  this.props.screenProps.setLowVisMode(!isLowVisMode);
                }}
              >
                <img
                  className="icon-toggle"
                  src={
                    isLowVisMode
                      ? this.props.screenProps.darkMode
                        ? toggleOnDark
                        : toggleOn
                      : this.props.screenProps.darkMode
                      ? toggleOffDark
                      : toggleOff
                  }
                  alt=""
                />
              </div>
            </div>
            <div className="fontPopoverRow" />
          </div>
        ) : null}

        {this.state.tab === "Fonts" ? (
          <div>
            <div className="fontPopoverRow" onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "Inter")}>
              <div className="fontPopoverTitle fontPopoverTitleInter">Default (Inter)</div>
              {this.props.screenProps.selectedFontFamily === "Inter" ? (
                <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
              ) : null}
            </div>

            <div
              className="fontPopoverRow"
              onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "AtkinsonHyperlegible")}
            >
              <div className="fontPopoverTitle fontPopoverTitleAtkinsonHyperlegible">Atkinson Hyperlegible</div>
              {this.props.screenProps.selectedFontFamily === "AtkinsonHyperlegible" ? (
                <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
              ) : null}
            </div>

            <div
              className="fontPopoverRow"
              onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "Comic Sans MS")}
            >
              <div className="fontPopoverTitle fontPopoverTitleComicSans">Comic Sans</div>
              {this.props.screenProps.selectedFontFamily === "Comic Sans" ? (
                <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
              ) : null}
            </div>

            <div
              className="fontPopoverRow"
              onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "OpenDyslexic")}
            >
              <div className="fontPopoverTitle fontPopoverTitleOpenDyslexic">OpenDyslexic</div>
              {this.props.screenProps.selectedFontFamily === "OpenDyslexic" ? (
                <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
              ) : null}
            </div>

            <div className="fontPopoverRow" onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "Roboto")}>
              <div className="fontPopoverTitle fontPopoverTitleRoboto">Roboto</div>
              {this.props.screenProps.selectedFontFamily === "Roboto" ? (
                <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
              ) : null}
            </div>

            <div
              className="fontPopoverRow"
              onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "RobotoSerif")}
            >
              <div className="fontPopoverTitle fontPopoverTitleRobotoSerif">Roboto Serif</div>
              {this.props.screenProps.selectedFontFamily === "RobotoSerif" ? (
                <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
              ) : null}
            </div>

            <div
              className="fontPopoverRow"
              onClick={this.props.screenProps.setSelectedFontFamily.bind(this, "Verdana")}
            >
              <div className="fontPopoverTitle fontPopoverTitleVerdana">Verdana</div>
              {this.props.screenProps.selectedFontFamily === "Verdana" ? (
                <img alt="" className="icon-44 accountSwitcherTickIcon" src={iconTickDark} />
              ) : null}
            </div>

            <div className="fontPopoverRow" />
          </div>
        ) : null}

        {this.state.tab === "Speech" ? (
          <div>
            <div className="fontPopoverRow">
              <div>Show text-to-speech</div>
              <IonToggle
                color="success"
                mode="ios"
                checked={this.props.screenProps.showTextToSpeech}
                onIonChange={(e) => this.props.screenProps.setShowTextToSpeech(e.detail.checked)}
              />
            </div>

            {this.props.screenProps.showTextToSpeech ? (
              <div className="fontPopoverRow">
                <div>Speech speed</div>
                <IonRange
                  mode="ios"
                  value={this.props.screenProps.textToSpeechSpeed}
                  ticks={false}
                  snaps={true}
                  min={1}
                  max={9}
                  onIonChange={(e) => this.props.screenProps.setTextToSpeechSpeed(e.detail.value as any)}
                />
              </div>
            ) : null}
            <div className="fontPopoverRow" />
          </div>
        ) : null}

        {this.state.tab === "Display" ? (
          <div>
            <div className="fontPopoverAppearance">
              <IonSegment
                mode="ios"
                onIonChange={(e) => {
                  if (e.detail.value === "Auto" || e.detail.value === "Light" || e.detail.value === "Dark") {
                    this.props.screenProps.setAppearance(e.detail.value);
                  }
                }}
                value={this.props.screenProps.appearance}
              >
                <IonSegmentButton value="Auto">
                  <IonLabel>Auto</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="Light">
                  <IonLabel>Light</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="Dark">
                  <IonLabel>Dark</IonLabel>
                </IonSegmentButton>
              </IonSegment>
            </div>

            <div className="fontPopoverRow">
              <div>Colour Filter</div>
              <IonToggle
                color="success"
                mode="ios"
                checked={this.props.screenProps.showColorFilter}
                onIonChange={(e) => this.props.screenProps.setShowColorFilter(e.detail.checked)}
              />
            </div>

            {this.props.screenProps.showColorFilter ? (
              <div className="fontPopoverAppearance">
                <HuePicker
                  width="100%"
                  color={this.props.screenProps.filterColor}
                  onChange={(color) =>
                    this.props.screenProps.setFilterColor({
                      r: color.rgb.r,
                      g: color.rgb.g,
                      b: color.rgb.b,
                      a: this.props.screenProps.filterColor.a,
                    })
                  }
                />
                <div className="fontPopoverApperanceSeparator" />
                <AlphaPicker
                  width="100%"
                  color={this.props.screenProps.filterColor}
                  onChange={(color) =>
                    this.props.screenProps.setFilterColor({
                      r: color.rgb.r,
                      g: color.rgb.g,
                      b: color.rgb.b,
                      a: color.rgb.a != null && color.rgb.a < 0.8 ? color.rgb.a : 0.8,
                    })
                  }
                />
              </div>
            ) : null}

            {this.props.features.includes("freezeFirstColumnMedTable") ? (
              <div className="fontPopoverRow">
                <div>Freeze first column in meds tables</div>
                <IonToggle
                  color="success"
                  mode="ios"
                  checked={this.props.screenProps.freezeFirstDrugColumn}
                  onIonChange={(e) => this.props.screenProps.setFreezeFirstDrugColumn(e.detail.checked)}
                />
              </div>
            ) : null}

            {this.props.screenProps.keepScreenAwakeSupported ? (
              <div className="fontPopoverRow">
                <div>Always On</div>
                <IonToggle
                  color="success"
                  mode="ios"
                  checked={this.props.screenProps.keepScreenAwake}
                  onIonChange={(e) => this.props.screenProps.setKeepScreenAwake(e.detail.checked)}
                />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}

export default FontPopover;
